export enum ActionButtonIcons {
  PENCIL = 'fa-pencil',
  TRASH = 'fa-trash',
  STAR = 'fa-star',
  CLIPBOARD = 'fa-clipboard',
  SEARCH = 'fa-search',
  MAIL = 'fa-clipboard',
  DOWNLAOD = 'fa-star'
}
